import UI from "../shared/Components/UI/js";
import ServiceApi from "./service";

class GetStreamApi {
    async getGetStreamToken() {
        const response = await ServiceApi.get(`/get-stream/token`, null, true);
        if (response?.status === 200) {
            const data = UI.extract_data(response);
            data.status = 200;
            return data;
        } else {
            return {
                status: response?.status || "",
                data: response?.data?.d || "",
                message: response?.data?.m || ""
            }
        }
    }
}

export default new GetStreamApi()